import { useState, useMemo } from "react"

const useQueue = (initialItems = []) => {
  const [queue, setQueue] = useState(initialItems)

  return useMemo(() => ({
    add: item => queue.push(item),
    next: () => {
      let head = null

      setQueue(queue => {
        head = queue.shift()
        return queue
      })
      
      return head
    },
    isEmpty: queue.length > 0
  }), [queue])
}
export default useQueue